import { createContext } from 'svelte';

export const [getInsideModalContext, setInsideModalContext] = createContext<boolean>();
